// ratio to enlarge polygons before combining them, to ensure they will intersect
export const compoundScaleRatio = 1.0001;

export const TERRITORY_BANNER_CLASS_NAME = "mmc-territories-banner";
